module.exports = __webpack_public_path__ + "img/atendente.c26a50c6.png";